import { createAnimations } from "@tamagui/animations-react-native";
import { createTamagui } from "tamagui";

import fonts from "./fonts";
import { themes } from "./themes";
import { tokens } from "./tokens";

export const mdMinWidth = 480;
export const lgMinWidth = 768;
export const xlMinWidth = 1000;

export const tamaguiConfig = createTamagui({
  settings: {
    fastSchemeChange: true,
    onlyAllowShorthands: false,
    shouldAddPrefersColorThemes: true,
    addThemeClassName: "body",
    styleCompat: "legacy", // Keep legacy flex behavior so we don't have to manually add flexGrow/flexShrink/flexBasis at every call site
    defaultPosition: "relative", // Keep tamagui legacy behavior
  },
  themes,
  tokens,
  animations: createAnimations({
    standard: {
      speed: 15,
      bounciness: 0,
    },
    bouncy: {
      speed: 12,
      bounciness: 10,
    },
  }),
  media: {
    md: { minWidth: mdMinWidth },
    lg: { minWidth: lgMinWidth },
    maxLg: { maxWidth: lgMinWidth },
    xl: { minWidth: xlMinWidth },
  },
  defaultFont: "sans-serif",
  fonts,
});

export default tamaguiConfig;

export type Conf = typeof tamaguiConfig;

declare module "tamagui" {
  interface TamaguiCustomConfig extends Conf {}
  interface TypeOverride {
    // Using a hyphen in the group name will break it! https://github.com/tamagui/tamagui/issues/1946#issuecomment-1847115042
    groupNames(): "iconButton" | "tertiaryButton";
  }
}
